import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

// Send button gated by a track from sendTrackRules' compute*Track: the track
// decides whether it renders at all, whether it is clickable, and why not.
//
// "upgrade" and "stripe-hint" modes stay clickable on purpose — the parent turns
// those clicks into the Upgrade modal / Payment connection prompt instead of a
// doomed request. Only "disabled" (a missing field, or no mailbox for a
// contract) actually blocks, and a disabled Button swallows mouse events, so
// the tooltip needs the wrapping span.
const SendButton = ({ track = {}, sending = false, onClick, children }) => {
  if (!track.show) return null;

  const button = (
    <Button
      variant="primary"
      size="sm"
      disabled={Boolean(track.disabled) || sending}
      onClick={onClick}
    >
      {children}
    </Button>
  );

  if (!track.tooltip) return button;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{track.tooltip}</Tooltip>}
    >
      <span className="d-inline-block">{button}</span>
    </OverlayTrigger>
  );
};

export default SendButton;
